// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Paymentallocation, ContactUs, UserPortfolio, MultibaggerAllocation } from '../../api/portfolio';
import { addPortfolio, getService, updatePortfolio, getMultibaggerListService, getSampleService } from '../../api/service';

const PaymentallocationApi = createAsyncThunk(
    'portfolio/loginUser',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await Paymentallocation(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);
const MultibaggerAllocationApi = createAsyncThunk(
    'multibagger',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await MultibaggerAllocation(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const getServiceApi = createAsyncThunk(
    'portfolio/service',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await getService(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);
const getSampleServiceApi = createAsyncThunk(
    'sampleportfolio/service',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await getSampleService(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const getMultibaggerListServiceApi = createAsyncThunk(
    'multibagger/service',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await getMultibaggerListService();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);
const addPortfolioApi = createAsyncThunk(
    'portfolio/addPortfolio',
    async (payload, { rejectWithValue }) => {
        try {
            if (payload.isInitial) {
                delete payload['isInitial']
                return await updatePortfolio(payload);
            } else {
                delete payload['isInitial']
                delete payload['id']
                return await addPortfolio(payload);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const ContactUsApi = createAsyncThunk(
    'portfolio/contact-us',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await ContactUs(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);
const UserPortfolioApi = createAsyncThunk(
    'portfolio/userportfolio',
    async (payload, { rejectWithValue }) => {
        try {
            const data = await UserPortfolio(payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);
const initialState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    showotp: true,
    userDetail: null,
    authState: false,
    portFolioList: [],
    userPortFolioList: [],
    sampleportFolioList: [],
    sampleuserPortFolioList: [],
    userPortfolio: {}
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(MultibaggerAllocationApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(MultibaggerAllocationApi.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload);
                
                // state.showotp = false
                // state.token = action.payload.token;
                // state.userDetail = { multibaggerAllocation: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(MultibaggerAllocationApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(PaymentallocationApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(PaymentallocationApi.fulfilled, (state, action) => {
                state.loading = false;
                state.showotp = false
                // state.token = action.payload.token;
                state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(PaymentallocationApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(getServiceApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(getServiceApi.fulfilled, (state, action) => {
                state.loading = false;
                state.showotp = false
                state.portFolioList = action.payload.data.portFolioList
                state.userPortFolioList = action.payload.data.userPortFolioList
                // state.token = action.payload.token;
                state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(getServiceApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(getSampleServiceApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(getSampleServiceApi.fulfilled, (state, action) => {
                state.loading = false;
                state.showotp = false
                state.sampleportFolioList = action.payload.data
                // state.token = action.payload.token;
                // state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(getSampleServiceApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(getMultibaggerListServiceApi.pending, state => {
                state.loading = true;
                state.error = null;
                // state.showotp = true
            })
            .addCase(getMultibaggerListServiceApi.fulfilled, (state, action) => {
                state.loading = false;
                // state.showotp = false
                state.userMultibaggerData = action.payload.data
            })
            .addCase(getMultibaggerListServiceApi.rejected, (state, action) => {
                state.loading = false;
                // state.showotp = true
                state.error = action.payload;
            })
            .addCase(addPortfolioApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(addPortfolioApi.fulfilled, (state, action) => {
                state.loading = false;
                state.showotp = false
                // state.portFolioList = action.payload.data.portFolioList
                // state.userPortFolioList = action.payload.data.userPortFolioList
                // state.token = action.payload.token;
                state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(addPortfolioApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(ContactUsApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(ContactUsApi.fulfilled, (state, action) => {
                state.loading = false;
                state.showotp = false
                // state.portFolioList = action.payload.data.portFolioList
                // state.userPortFolioList = action.payload.data.userPortFolioList
                // state.token = action.payload.token;
                state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(ContactUsApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })
            .addCase(UserPortfolioApi.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(UserPortfolioApi.fulfilled, (state, action) => {
                state.loading = false;
                // state.portFolioList = action.payload.data.portFolioList
                // state.userPortFolioList = action.payload.data.userPortFolioList
                // state.token = action.payload.token;
                state.userPortfolio = action.payload.data
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(UserPortfolioApi.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })

    },
});

export const { logout } = authSlice.actions;
export { PaymentallocationApi, MultibaggerAllocationApi, getServiceApi, addPortfolioApi, getMultibaggerListServiceApi, ContactUsApi, UserPortfolioApi, getSampleServiceApi }
export default authSlice.reducer;
